function hashToHue(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % 360;
}

/** Deterministic initials-based avatar — stands in for a profile photo without needing upload infra. */
export function Avatar({ name, seed, size = 32 }: { name: string; seed?: string; size?: number }) {
  const initial = name.trim().charAt(0).toUpperCase() || "?";
  const hue = hashToHue(seed ?? name);

  return (
    <span
      aria-hidden
      className="inline-flex shrink-0 items-center justify-center rounded-full font-medium text-white"
      style={{ width: size, height: size, fontSize: size * 0.45, backgroundColor: `hsl(${hue} 55% 42%)` }}
    >
      {initial}
    </span>
  );
}
